// Formatting lives on the client (the API emits integer *_cents + ISO dates and
// never formats), so money and dates render in the user's Dutch locale.

export function formatMoney(cents, currency = "EUR") {
  if (cents == null) return "";
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency }).format(cents / 100);
}

export function formatDate(iso, options = { day: "numeric", month: "long" }) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("nl-NL", options).format(new Date(iso));
}

export function formatMonth(iso) {
  return formatDate(iso, { month: "long" });
}

// Whole days from today (local) to an ISO date. Negative when already past.
export function daysUntil(iso) {
  if (!iso) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(iso);
  target.setHours(0, 0, 0, 0);
  return Math.round((target - today) / 86_400_000);
}

// Mollie-style interval strings ("1 month") → Dutch "per maand". Falls back to the
// raw value so an unmapped interval still renders something truthful.
export function formatInterval(interval) {
  return (
    {
      "1 month": "per maand",
      "3 months": "per kwartaal",
      "6 months": "per half jaar",
      "12 months": "per jaar",
      "1 year": "per jaar",
    }[interval] ?? interval
  );
}
